"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

const TrackAnalytics = () => {
    const pathname = usePathname();

    useEffect(() => {

        const trackAnalytics = async () => {
            // Wait for window to be fully loaded to not interfere with LCP/FCP
            if (document.readyState !== 'complete') {
                window.addEventListener('load', () => trackAnalytics(), { once: true });
                return;
            }

            const ref = new URLSearchParams(window.location.search).get("ref");
            const referrer = document.referrer || "";
            const userAgent = navigator.userAgent;
            const apiUrl = window.location.hostname === "localhost"
                ? "http://localhost:5000/api/analytics/track"
                : "https://devcodzbackend.vercel.app/api/analytics/track";

            // Set the page to 'Home' if it's empty or just "/"
            const page = pathname && pathname !== "/" ? pathname.replace(/^\/+/g, "") : "Home";
            const website = window.location.hostname;

            let uniqueVisitorId = sessionStorage.getItem("uniqueVisitorId");

            if (!uniqueVisitorId) {
                uniqueVisitorId = Math.random().toString(36).substring(2) + Date.now().toString(36);
                sessionStorage.setItem("uniqueVisitorId", uniqueVisitorId);
            }

            // Get country name using IP geolocation
            // let country = "Unknown";
            // try {
            //     const ipResponse = await fetch('http://ip-api.com/json/');
            //     const ipData = await ipResponse.json();
            //     country = ipData.country || 'Unknown';
            //     console.log("User country:", country);  // Log the country
            // } catch (error) {
            //     console.error("Error fetching country:", error);
            // }

            // Send the tracking data to the backend
            fetch(apiUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    website,  // Sending website from the hostname
                    page,     // Sending sanitized page name
                    referrer, // Sending referrer
                    source: ref || "",  // Sending the ref query parameter if available
                    uniqueVisitorId, // Sending unique visitor ID
                    // country:country ||"",  // Sending country from geolocation
                })
            }).catch(err => console.error("Analytics tracking failed:", err));
        };

        trackAnalytics();

    }, [pathname]);

    return null;
};

export default TrackAnalytics;
